export default "__VITE_ASSET__5auBkXqi__"